import { Component } from '@angular/core';
import { AuthService, StateService } from 'src/app/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Product2, CompanyType, ProductWorkflowState } from 'situview-webapi-client';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ArtifactViewerDialogComponent } from 'src/app/components';

@Component({
  selector: 'product-catalog',
  templateUrl: './product-catalog.component.html',
  styleUrls: ['./product-catalog.component.scss']
})

export class ProductCatalogComponent extends SituBaseComponent {
  /* Search */
  searchTerm = "";
  productTypeFilter: string | undefined;
  productStateFilter: ProductWorkflowState | undefined;
  companyIdFilter: string | undefined;
  productRangeFilter: string | undefined;

  dialogRef: MatDialogRef<ArtifactViewerDialogComponent> | undefined;

  /* Query Parameters */
  readonly FilterParamName: string = "filter";
  readonly CompanyParamName: string = "company";
  readonly ProductTypeParamName: string = "type";
  readonly ProductStateParamName: string = "state";
  readonly ProductRangeParamName: string = "range";

  public firstSelectedCompanyChange = true;

  constructor(
    authService: AuthService,
    stateService: StateService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog) {
    super(authService, stateService);

    if (this.route.snapshot.queryParams[this.FilterParamName]) {
      this.searchTerm = this.route.snapshot.queryParams[this.FilterParamName];
    }

    if (this.route.snapshot.queryParams[this.CompanyParamName]) {
      this.companyIdFilter = this.route.snapshot.queryParams[this.CompanyParamName];
    }

    if (this.route.snapshot.queryParams[this.ProductTypeParamName]) {
      this.productTypeFilter = this.route.snapshot.queryParams[this.ProductTypeParamName];
    }

    if (this.route.snapshot.queryParams[this.ProductStateParamName]) {
      this.productStateFilter = Number(this.route.snapshot.queryParams[this.ProductStateParamName]);
    }

    if (this.route.snapshot.queryParams[this.ProductRangeParamName]) {
      this.productRangeFilter = this.route.snapshot.queryParams[this.ProductRangeParamName];
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected onSelectedCompanyChange(): void {
    // When filtering the company we want to do the following:-
    // On First SelectedCompanyChange
    //   Filter if the company URL Param is set (done in the constructor)
    //     Otherwise
    //   Filter to the selected company if it is a Manufacturer
    // Else:
    //   Filter to the selected company

    if (this.firstSelectedCompanyChange) {
      this.firstSelectedCompanyChange = false;

      if (!this.companyIdFilter) {
        if (this.selectedCompany?.type === CompanyType.Manufacturer) {
          this.companyIdFilter = this.selectedCompany?.id;
          this.updateParams();
        }
      }
    } else {
      this.companyIdFilter = this.selectedCompany?.id;
      this.updateParams();
    }
  }

  onProductSelected(products: Product2[]) {
    var product = products[0];
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
  
    const dialogWidth = `${Math.round((70 / 100) * screenWidth)}px`;
    const dialogHeight = `${Math.round((90 / 100) * screenHeight)}px`;

    if (product?.previewArtifactId) {
      this.dialogRef = this.dialog.open(ArtifactViewerDialogComponent, {
        width: dialogWidth,
        height: dialogHeight,
        data: {
          fileName: "product.glb",
          artifactId: product.previewArtifactId
        }
      });
    }
  }

  onFilterCompanyId(companyId: string) {
    this.companyIdFilter = companyId;
    this.updateParams();
  }

  onFilterProductTypeId(productTypeId: string) {
    this.productTypeFilter = productTypeId;
    this.updateParams();
  }

  onFilterProductState(productState: ProductWorkflowState) {
    this.productStateFilter = productState;
    this.updateParams();
  }

  onSearchTermChanged(searchTerm: string) {
    this.searchTerm = searchTerm;
    this.updateParams();
  }

  onFilterProductRange(rangeId: string) {
    this.productRangeFilter = rangeId;
    this.updateParams();
  }

  private updateParams() {
    const queryParams: { [key: string]: any } = {};

    if (this.searchTerm) {
      queryParams.filter = this.searchTerm;
    }
    if (this.companyIdFilter) {
      queryParams.company = this.companyIdFilter;
    }
    if (this.productTypeFilter) {
      queryParams.type = this.productTypeFilter;
    }
    if (this.productStateFilter) {
      queryParams.state = this.productStateFilter;
    }
    if (this.productRangeFilter) {
      queryParams.range = this.productRangeFilter;
    }

    const urlTree = this.router.createUrlTree([], {
      queryParamsHandling: "merge",
      preserveFragment: true,
      queryParams: queryParams
    });

    if (!this.searchTerm) {
      delete urlTree.queryParams[this.FilterParamName];
    }
    if (!this.companyIdFilter) {
      delete urlTree.queryParams[this.CompanyParamName];
    }
    if (!this.productTypeFilter) {
      delete urlTree.queryParams[this.ProductTypeParamName];
    }
    if (!this.productStateFilter) {
      delete urlTree.queryParams[this.ProductStateParamName];
    }
    if (!this.productRangeFilter) {
      delete urlTree.queryParams[this.ProductRangeParamName];
    }
  
    this.router.navigateByUrl(urlTree);
  }
}
